const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
const SENTRY_ENVIRONMENT =
    process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production';
const SENTRY_TRACES_SAMPLE_RATE = parseFloat(
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE
);
export { SENTRY_DSN, SENTRY_ENVIRONMENT, SENTRY_TRACES_SAMPLE_RATE };
